import { usePointsHistory } from "#/services/kyan/hooks/usePointsHistory";
import { useRedeemersTradeStats } from "#/services/kyan/hooks/useTradeStats";
import { useReferralsByAccount } from "#/services/referrals/hooks/useReferralsByAccount";

export interface EarningsValues {
  referralBalance: number;
  krystalsEarned: number;
}

export const useEarningsController = (): EarningsValues => {
  const { redeemers } = useReferralsByAccount();
  const { data } = usePointsHistory();
  const {
    data: { referralsSummary },
  } = useRedeemersTradeStats(redeemers);

  return {
    referralBalance: referralsSummary.activeReferrals,
    krystalsEarned: Math.floor(data?.summary.lifetimePoints ?? 0),
  };
};
